import logo from '../../static/img/logo.svg';
import icon_user from '../../static/img/icon-user.svg';
import burger from '../../static/img/burger-1.svg';
import burger2 from '../../static/img/burger-2.svg';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsLogin } from '../home/homeSlice';
import { useNavigate } from 'react-router-dom';
import { MAIN_ROUTE } from '../../static/vars';

export function Header() {
    const isLogin = useSelector(selectIsLogin)
    const navigate = useNavigate()

    const [showMenu, setShowMenu] = useState(false);


    const handleLogin = () => {
        window.ym(90426649,'reachGoal','voyti')

        if (isLogin) navigate(MAIN_ROUTE + '/personal', { replace: true })
        else navigate(MAIN_ROUTE + '/login', { replace: true })
    }

    return (
        <header className="header" id="header">
            <div className="header-contant">
                <div className="header-contant-logo">
                    <a to="/strahovanie-ipoteky"><img src={logo} alt="logo" /></a>
                </div>
                <div className="header-contant-user">
                    <div onClick={handleLogin} className="user"><img src={icon_user} alt="logo" /></div>
                </div>
                <div onClick={()=>setShowMenu(!showMenu)} className="header-contant-menu">
                    <img className="burger-1" src={burger} alt="logo" />
                </div>
            </div>
            {showMenu &&
                <div className="mobile-container">
                    <img onClick={() => setShowMenu(!showMenu)} className="burger-2" src={burger2} alt="logo" />
                    <div className="mobile-container-vnutr">
                        <ul className="main-menu">
                        <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/" className="txt_nowrap">Страхование ипотеки</a></li>
                            <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/o-kompanii/">О компании</a></li>
                            <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/promo/">Акции</a></li>
                            <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/#policies">Как выбрать полис</a></li>
                            <li class="main-menu-up"><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/#faq">Частые вопросы</a></li>
                            <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/news/">Новости</a></li>
                            <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/novostroiki/">Новостройки</a></li>
                            <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/banks/">Банки</a></li>
                        </ul>
                    </div>
                </div>
            }
        </header>
    )
}